import React, { useCallback, useEffect, useState } from "react";
import {
  Typography,
  Button,
  Paper,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import { Formik } from "formik";
import { useParams } from "react-router-dom";
import { getCompanyTokenAPI } from "../../apis/getCompanyTokenAPI";
import { updateCompanyTokenAPI } from "../../apis/updateCompanyTokenAPI";
import useStyles from "../../styles/profileCardStyle";
import { useTranslation } from "../../langs/useTranslation";

const CompanyTokenCard = () => {
  const classes = useStyles();
  const { t } = useTranslation("accountCenter");
  const { company_id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [initCompanyTokenNumber, setCompanyTokenNumber] = useState(null);

  const getCompanyToken = useCallback(async () => {
    setIsLoading(true);

    const companyTokenNumber = await getCompanyTokenAPI(company_id);
    setCompanyTokenNumber(companyTokenNumber);
    console.log(companyTokenNumber);

    setIsLoading(false);
  }, [company_id]);

  const renewCompayToken = async () => {
    setIsLoading(true);
    const newCompanyTokenNumber = await updateCompanyTokenAPI(company_id);
    setCompanyTokenNumber(newCompanyTokenNumber);
    console.log(newCompanyTokenNumber);
    setIsLoading(false);
  };

  useEffect(() => {
    getCompanyToken();
  }, [getCompanyToken]);

  const initialValues = {
    companyTokenNumber: initCompanyTokenNumber,
  };

  return (
    <Paper elevation={0} className={`height-100 ${classes.companyProfileForm}`}>
      {isLoading ? (
        <div className={classes.loadingWrap}>
          <CircularProgress />
        </div>
      ) : (
        <Formik initialValues={initialValues}>
          {({ values }) => (
            <form className={classes.mainContent}>
              <TextField
                name="companyVerifyToken"
                value={values.companyTokenNumber}
                className={`${classes.input} ${classes.inputLong}`}
                label={t("companyTokenCard.token")}
                disabled={true}
              />
              <Button color="primary" onClick={renewCompayToken}>
                {t("companyTokenCard.renew")}
              </Button>
            </form>
          )}
        </Formik>
      )}
    </Paper>
  );
};

export default CompanyTokenCard;
